var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AttributesMappingGrid',{attrs:{"attributeNames":_vm.attributeNames,"directionColumnName":"JumpCloud to export?","directoryName":_vm.directoryName,"storeName":_vm.storeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }